import { render, staticRenderFns } from "./inventory_table_new.vue?vue&type=template&id=04318c49&scoped=true"
import script from "./inventory_table_new.vue?vue&type=script&lang=js"
export * from "./inventory_table_new.vue?vue&type=script&lang=js"
import style0 from "./inventory_table_new.vue?vue&type=style&index=0&id=04318c49&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04318c49",
  null
  
)

export default component.exports